export const cxHours = {
  weekday: `10am – 9pm`,
  sat: `10am – 6pm`,
  sun: `10am – 6pm`,
};
